import React from "react";
import { Modal, Space, Typography, Image, Form, Input, Radio, DatePicker, notification } from "antd";
import { observer } from "mobx-react";
import { Store } from "../../store/Store";
import { Api } from "../../common/Api";
import moment from "moment-timezone";

const { TextArea } = Input;

export const IdCheckDlg = observer(({ onClose }) => {
  const { idCheck } = Store;
  const [form] = Form.useForm();

  const save = () => {
    return form.validateFields().then((values) => {
      idCheck.saving = true;

      let expirationDate = undefined;
      if (values.expirationDate) {
        expirationDate = moment(values.expirationDate).format("YYYY-MM-DD");
      }

      return Api.idcheck
        .confirm({ id: idCheck.selected.id, ...values, expirationDate })
        .then((res) => {
          notification.info({ message: "Success!" });
          idCheck.refresh();
          idCheck.selected = null;
        })
        .finally(() => (idCheck.saving = false));
    });
  };

  return (
    <Modal
      title="User ID Verification"
      visible={true}
      maskClosable={false}
      onCancel={() => onClose(false)}
      width={800}
      onOk={save}
    >
      <Form
        form={form}
        initialValues={{
          approve: true,
          expirationDate: idCheck.selected.expirationDate ? moment(idCheck.selected.expirationDate) : undefined,
        }}
      >
        <Typography.Title level={5}>User Info in App:</Typography.Title>
        <Typography.Paragraph>{idCheck.selected?.user?.name}</Typography.Paragraph>
        <Typography.Title level={5}>User Info in ID Card:</Typography.Title>
        <Typography.Paragraph>
          First name: {idCheck.selected?.firstName} <br />
          Last name: {idCheck.selected?.lastName}
        </Typography.Paragraph>

        <Typography.Title level={5}>ID Type: {idCheck.selected.type}</Typography.Title>

        <Space direction="horizontal" style={{ width: "100%", padding: "20px 0" }}>
          <Image width={200} src={`${idCheck.selected.frontUrl}`} />
          {idCheck.selected.backUrl && <Image width={200} src={`${idCheck.selected.backUrl}`} />}

          {idCheck.selected.videoImage && <Image width={200} src={idCheck.selected.videoImage} />}
{/* 
          {idCheck.selected.videoUrl && (
            <video
              style={{ width: 200 }}
              controls={true}
              src={`https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/${idCheck.selected.videoUrl}`}
            ></video>
          )} */}
        </Space>

        {idCheck.selected.status === "Pending" ? (
          <>
            <Form.Item label="Approve or Reject" name="approve">
              <Radio.Group
                onChange={(v) => {
                  console.log(v.target);
                  idCheck.isReject = !v.target.value;
                }}
              >
                <Radio.Button value={true}>Approve</Radio.Button>
                <Radio.Button value={false}>Reject</Radio.Button>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label="Expiration"
              name="expirationDate"
              rules={[{ required: idCheck.selected.type === "Driving License" && !idCheck.isReject }]}
            >
              <DatePicker />
            </Form.Item>

            <Form.Item label="Reject Type" name="rejectReason" rules={[{ required: idCheck.isReject }]}>
              <Radio.Group>
                <Space direction="vertical">
                  <Radio value="ID picture unclear. Please try again."> ID picture unclear. Please try again. </Radio>
                  <Radio value="Facial recognition failed. Please try again.">
                    Facial recognition failed. Please try again.
                  </Radio>
                  <Radio value="Valid ID needed."> Valid ID needed. </Radio>
                  <Radio value="The name on your ID does not match your registered name. Please contact us at help@foo-moo.com to clarify the discrepancy.">
                    The name on your ID does not match your registered name. Please contact us at help@foo-moo.com to
                    clarify the discrepancy.
                  </Radio>
                  <Radio value="ID verification failed."> ID verification failed. </Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item label="Notes" name="notes">
              <TextArea placeholder="Input reject reason..." />
            </Form.Item>
          </>
        ) : (
          <>
            <Typography.Title level={5}>Status: {idCheck.selected.status}</Typography.Title>
            {idCheck.selected.reason && <Typography.Paragraph>{idCheck.selected.reason}</Typography.Paragraph>}

            {idCheck.selected.expirationDate && (
              <Typography.Title level={5}>Expiration Date:{idCheck.selected.expirationDate}</Typography.Title>
            )}

            <Typography.Title level={5}>Notes:</Typography.Title>
            <Typography.Paragraph>{idCheck.selected?.notes}</Typography.Paragraph>
          </>
        )}
      </Form>
    </Modal>
  );
});
